import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

import samplePDF from './files/TermsOfUse.pdf';
import './TermsOfUseMui.css'
export default function TermsOfUseMui(props) {
  const { closeModal, hasToAccept, noButtons, isFullScreen } = props;

  const handleCloseModal = () => {
    closeModal();
  };

  const widthParam = isFullScreen ? "100%" : "550px";

  return (
    <div class="terms-of-use-body" style={{ width: widthParam}}>
      <Box display="flex" p={1} bgcolor="background.paper">
        <Box p={1} width="100%" style={{ display: "flex" }}>     
            <embed src={samplePDF} width="100%" height="800" alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"/>
        </Box>
      </Box>
     
      <Box style={{ float: "right" }}>
        {" "}    
        {
          noButtons === true ? "" : 
          <Button onClick={handleCloseModal} color="primary">
          {
            hasToAccept ? "Acepto los términos de uso" : "Listo!"
          }        
        </Button>
          
        }  
        
      </Box>
    </div>
  );
}
